// Inline data-URI placeholders. Не зависим от внешних доменов
// (раньше via.placeholder.com отдавал ERR_CONNECTION_CLOSED и спамил консоль).

const svg = (w, h, bg, label, fg = '#ffffff') => {
  const safe = String(label).replace(/[<>&]/g, '');
  const fontSize = Math.round(Math.min(w, h) / 4);
  const body = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${bg}"/>
          <stop offset="100%" stop-color="#7c3aed"/>
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#g)"/>
      <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central"
            font-family="system-ui,-apple-system,Segoe UI,Roboto,sans-serif"
            font-size="${fontSize}" font-weight="700" fill="${fg}">${safe}</text>
    </svg>`.trim();
  return `data:image/svg+xml;utf8,${encodeURIComponent(body)}`;
};

export const COURSE_COVER_FALLBACK = svg(400, 240, '#4f46e5', 'Course');
export const COURSE_COVER_FALLBACK_SM = svg(300, 150, '#4f46e5', 'Course');
export const AVATAR_FALLBACK = svg(96, 96, '#6b7280', 'U');

// Хук для <img onError> — единая точка, чтобы не плодить inline-функции
// и заодно блокировать рекурсивные onError-петли.
export const setFallback = (fallback) => (e) => {
  const img = e.currentTarget;
  if (img.dataset.fallback === '1') return;
  img.dataset.fallback = '1';
  img.src = fallback;
};
